export const slickHP = {
  dots: true,
  infinite: true,
  speed: 500,
  autoplay: true,
  autoplaySpeed: 5000,
  fade: true,
  cssEase: 'linear',
  pauseOnHover:true,
  adaptiveHeight: true,
  rows: 1,
  slidesToShow: 1,
};
export const slickProdutosRecentes = {
  infinite: false,
  rows: 2,
  slidesToShow: 4,
  slidesToScroll: 4,
  dots: true,
  arrows: true,
  appendDots: '.slide-p-dots',
  prevArrow: '.slide-p-prev',
  nextArrow: '.slide-p-next',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        rows: 1,
        slidesToShow: 1,
        slidesPerRow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
      },
    },
  ],
};
export const slickProdutosRecentesLess = {
  infinite: false,
  rows: 1,
  slidesToShow: 4,
  slidesToScroll: 4,
  dots: true,
  arrows: true,
  appendDots: '.slide-p-dots',
  prevArrow: '.slide-p-prev',
  nextArrow: '.slide-p-next',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        rows: 1,
        slidesToShow: 1,
        slidesPerRow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
      },
    },
  ],
};

export const slickProdutos = {
  infinite: false,
  rows: 1,
  slidesToShow: 4,
  slidesToScroll: 4,
  dots: true,
  arrows: true,
  appendDots: '.slide-p-dots',
  prevArrow: '.slide-p-prev',
  nextArrow: '.slide-p-next',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        rows: 1,
        slidesToShow: 1,
        slidesPerRow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 2000,
      },
    },
  ],
};

export const slickDisponiveisSearch = {
  infinite: false,
  rows: 1,
  slidesToShow: 4,
  slidesToScroll: 4,
  dots: true,
  arrows: true,
  appendDots: '.slide-p-dots',
  prevArrow: '.slide-p-prev',
  nextArrow: '.slide-p-next',
  responsive: [
  {
      breakpoint: 992,
      settings: {
        rows: 1,
        slidesToShow: 3,
        slidesPerRow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 2000,
      },
    },
    {
      breakpoint: 768,
      settings: {
        rows: 1,
        slidesToShow: 1,
        slidesPerRow: 1,
        slidesToScroll: 1,
        dots: true,
        arrows: true,
        autoplay: true,
        autoplaySpeed: 2000,
      },
    },
  ],
};

export const slickDisponiveis = {
  infinite: false,
  rows: 1,
  slidesToShow: 4,
  slidesToScroll: 4,
  dots: true,
  arrows: true,
  appendDots: '.slide-p-dots',
  prevArrow: '.slide-p-prev',
  nextArrow: '.slide-p-next',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        rows: 1,
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
      },
    },
    {
      breakpoint: 767,
      settings: {
        rows: 1,
        slidesToShow: 1,
        slidesPerRow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 2000,
      },
    },
  ],
};

export const slickArtigos = {
  infinite: false,
  rows: 1,
  slidesToShow: 3,
  slidesToScroll: 1,
  dots: true,
  arrows: true,
  appendDots: '.slide-d-dots',
  prevArrow: '.slide-d-prev',
  nextArrow: '.slide-d-next',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        rows: 1,
        slidesToShow: 1,
        slidesPerRow: 1,
        slidesToScroll: 1,
        dots: false,
      },
    },
  ],
};

export const slickDicas = {
  infinite: false,
  rows: 1,
  slidesToShow: 2,
  slidesToScroll: 2,
  dots: true,
  arrows: true,
  appendDots: '.slide-d-dots',
  prevArrow: '.slide-d-prev',
  nextArrow: '.slide-d-next',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        rows: 1,
        slidesToShow: 1,
        slidesPerRow: 1,
        slidesToScroll: 1,
        dots: false,
      },
    },
  ],
};

export const slickServicos = {
  slidesToShow: 2,
  slidesToScroll: 1,
  infinite: false,
  focusOnSelect: false,
  dots: true,
  swipe: false,
  arrows: true,
  appendDots: '.slide-m-dots',
  prevArrow: '.slide-m-prev',
  nextArrow: '.slide-m-next',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        swipe: false,
        arrows: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        swipe: false,
        arrows: true,
      },
    },
  ],
};

export const slickMarcas = {
  slidesToShow: 5,
  slidesToScroll: 1,
  infinite: false,
  dots: true,
  arrows: true,
  appendDots: '.slide-b-dots',
  prevArrow: '.slide-b-prev',
  nextArrow: '.slide-b-next',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
      },
    },
  ],
};

export const slickLogos = {
  slidesToShow: 4,
  slidesToScroll: 1,
  infinite: false,
  dots: true,
  arrows: true,
  appendDots: '.slide-b-dots',
  prevArrow: '.slide-b-prev',
  nextArrow: '.slide-b-next',
};

export const slickNoticias = {
  slidesToShow: 3,
  slidesToScroll: 1,
  infinite: false,
  dots: false,
  arrows: false,
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        appendDots: '.slide-n-dots',
        prevArrow: '.slide-n-prev',
        nextArrow: '.slide-n-next',
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        appendDots: '.slide-n-dots',
        prevArrow: '.slide-n-prev',
        nextArrow: '.slide-n-next',
      },
    },
  ],
};

export const slickFolhetos = {
  slidesToShow: 3,
  slidesToScroll: 3,
  dots: true,
  infinite: false,
  arrows: true,
  appendDots: '.slide-n-dots',
  prevArrow: '.slide-n-prev',
  nextArrow: '.slide-n-next',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: false,
        arrows: false,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        infinite: false,
      },
    },
  ],
};

export const slickCatalogo = {
  slidesToShow: 3,
  slidesToScroll: 3,
  infinite: false,
  dots: true,
  arrows: true,
  appendDots: '.slide-d-dots',
  prevArrow: '.slide-d-prev',
  nextArrow: '.slide-d-next',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
      },
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
      },
    },
  ],
};



// WEBPACK FOOTER //
// ./scripts/brico/slick.js